import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { ReactComponent as SearchIcon } from "assets/images/icons/icn_search.svg";
import { ReactComponent as SearchHoverIcon } from "assets/images/icons/icn_search_hover.svg";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: theme.shape.customBorderRadius[3],
    width: "250px",
    height: "33px",
    color: theme.palette.primary.greyPrimary,
    fontSize: theme.typography.customFontSize[1],
    backgroundColor: theme.palette.primary.background,
    "&:hover fieldset": {
      borderColor: theme.palette.primary.mainHover,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
    },
  },
  "& .MuiInputAdornment-root": {
    marginLeft: '6px',
  }
}));

const SearchInput = ({ value, onChange, placeholder, sx }) => {
  const [searchHover, setSearchHover] = useState(false);

  return (
    <StyledTextField
      variant="outlined"
      placeholder={placeholder ?? "Search"}
      sx={sx}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      onMouseEnter={() => setSearchHover(true)}
      onMouseLeave={() => setSearchHover(false)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {searchHover ? <SearchHoverIcon /> : <SearchIcon />}
          </InputAdornment>
        ),
      }}
      autoComplete="off"
    />
  );
};

export default SearchInput;
